import { Link, useLocation } from "react-router-dom";
import styles from './styles.module.scss'
import logo from '../../assets/logo.webp'

const Header = () => {
	const location = useLocation();
	if (location.pathname === '/') {
		return (
			<header className={styles.header}>
				<a href='#home' aria-label="Maneliada - Înapoi la începutul paginii">
					<img src={logo} alt="Maneliada" style={{ height: '2.5rem', width: 'auto' }} />
				</a>
			</header>
		)
	}
	return (
		<header className={styles.header}>
			<Link to="/" aria-label="Maneliada - Pagina principală">
				<img src={logo} alt="Maneliada" style={{ height: '2.5rem', width: 'auto' }} />
			</Link>
		</header>
	)
}

export default Header